import {Component, OnInit, ViewChild} from '@angular/core';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import { CustomerService } from 'src/app/services/business/customers/customer.service';
import { Router} from "@angular/router";

@Component({
  selector: 'app-customers-group',
  templateUrl: './customers-group.component.html',
  styleUrls: ['./customers-group.component.scss']
})
export class CustomersGroupComponent implements OnInit {
  keywordGroup = '';
  groups = [];
  loading = false;
  total;
  pageIndex = 1;
  pageSize = 10;
  query;
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  mapOfCheckedId = {};
  // tslint:disable-next-line:variable-name
  list_id = [];
  changeAction;
  // @ts-ignore
  @ViewChild('addGroup') addGroup;
  // @ts-ignore
  @ViewChild('deleteGroup') deleteGroup;
  // @ts-ignore
  @ViewChild('updateGroup') updateGroup;
  delete = {
    label: 'Xác nhận xóa nhóm đối tượng',
    value: ' <p class="mrb-10">Hệ thống sẽ xóa nhóm đối tượng này.</p>\n' +
      '          <p>Bạn có chắc chắn muốn xoá?</p>'
  };
  deletes = {
    label: 'Xác nhận xóa nhiều nhóm đối tượng',
    value: ' <p class="mrb-10">Hệ thống sẽ xóa những nhóm đối tượng này.</p>\n' +
      '          <p>Bạn có chắc chắn muốn xoá?</p>'
  };
  constructor(
    private customerService: CustomerService,
    private notification: NzNotificationService,
    private router: Router,
  ) { }

  ngOnInit() {
    localStorage.removeItem('groupIds');
    this.changeAction = undefined;
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.loadData();
  }
  loadData() {
    this.loading = true;
    this.query = {
      keyword: this.keywordGroup,
      page: this.pageIndex,
      page_size: this.pageSize
    };
    this.customerService.listGroup(this.query).subscribe(
      res => {
        this.loading = false;
        if (res.code === 1) {
          if (res.data.items.length === 0 && this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.loadData();
            return;
          }
          this.groups = res.data.items;
          this.total = res.data.totalElement;
          this.refreshStatus();
          return;
        }
        this.notification.create(
          'error',
          'Lấy danh sách nhóm đối tượng thất bại',
          res.message
        );
      },
      error => {
        this.loading  = false;
        this.notification.create(
          'error',
          'Lấy danh sách nhóm đối tương thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }
  searchGroup() {
    this.pageIndex = 1;
    this.loadData();
  }
  resetGroup() {
    this.keywordGroup = '';
    this.pageIndex = 1;
    this.loadData();
  }
  // =========add=============//
  addCustomersGroup() {
    this.addGroup.showModal();
  }
  successCreateGroup(event) {
    if (event === 1) {
      setTimeout(() => {
        this.resetGroup();
      }, 1000);
    }
  }
  showModalUpdateGroup(id?: string) {
    if (id) {
      this.updateGroup.showModal(id);
    }
  }
  successUpdateGroup(event) {
    if (event === 1) {
      setTimeout(() => {
        this.resetGroup();
      }, 1000);
    }
  }
  showModalDeleteGroup(text, id) {
    this.deleteGroup.showModal(text, id);
  }
  successDeleteGroup(event) {
    if (event.length) {
      const body = {
        body: {
          groupIds: event
        }
      };
      this.customerService.deleteGroup(body).subscribe(
        res => {
         if (res.code === 1) {
           this.mapOfCheckedId = {};
           this.list_id = [];
           this.changeAction = undefined;
           this.notification.success(
             'Thành công',
             'Xóa nhóm đối tượng thành công'
           );
           this.deleteGroup.handleCancel();
           setTimeout(() => {
             this.resetGroup();
           }, 1000);
         } else {
           this.notification.error(
             'Xóa nhóm đối tượng thất bại',
             res.message
           );
         }
         this.deleteGroup.success();
        },
        error => {
          this.deleteGroup.success();
          this.notification.error(
            'Xóa nhóm đối tượng thất bại',
            'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
          );
        }
      );
    }
  }
  actionsButton(event) {
    this.changeAction = event;
  }
  buttonSubmit() {
    // tslint:disable-next-line:triple-equals
    if (this.changeAction == 2 ) {
      this.deleteGroup.showModal(this.deletes, this.list_id);
    }
    // tslint:disable-next-line:triple-equals
    if (this.changeAction == 1 ) {
      // @ts-ignore
      localStorage.setItem('groupIds', this.list_id);
      this.router.navigate(['/business/media/create']);
    }
  }
  checkAll(value: boolean) {
    this.groups.forEach(item => (this.mapOfCheckedId[item.id] = value));
    this.refreshStatus();
  }
  refreshStatus() {
    if (this.groups.length > 0) {
      this.isAllDisplayDataChecked = this.groups.every(item => this.mapOfCheckedId[item.id]);
    } else {
      this.isAllDisplayDataChecked = false;
    }
    this.isIndeterminate = this.groups.some(item => this.mapOfCheckedId[item.id]) && !this.isAllDisplayDataChecked;
    for (const key in this.mapOfCheckedId) {
      if (this.mapOfCheckedId[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
  }
}
